export const Loader = () => {
    return (
        <div className="d-flex justify-content-center m-auto">
            <div
                className="spinner-border text-primary"
                style={{ width: "3rem", height: "3rem" }}
                role="status"
            >
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    );
};
